import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const NoRowsOverlayMessage = styled.div`
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: ${rem(20)};
  color: ${({ theme }) => theme.colors.gray600};
  margin-top: 96px;
`;
